import { render, staticRenderFns } from "./CollectionSearch.vue?vue&type=template&id=12f36955&scoped=true"
import script from "./CollectionSearch.vue?vue&type=script&lang=js"
export * from "./CollectionSearch.vue?vue&type=script&lang=js"
import style0 from "./CollectionSearch.vue?vue&type=style&index=0&id=12f36955&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f36955",
  null
  
)

export default component.exports